import { render } from "./DigitalizationView.vue?vue&type=template&id=196592d4&scoped=true"
import script from "./DigitalizationView.vue?vue&type=script&lang=js"
export * from "./DigitalizationView.vue?vue&type=script&lang=js"

import "./DigitalizationView.vue?vue&type=style&index=0&id=196592d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196592d4"]])

export default __exports__